import { Input } from 'antd';
import { CalculatorConfigType } from './calculatorsTypes';
import AntSelect from './padV2/AntSelect';
import { EkaFocosableElement } from '../../../common/types/EkaFocusable';
import { useEffect } from 'react';

export const CalculatorInputAndSelect: React.FC<{
    argsKey: string;
    config: CalculatorConfigType;
    onValueChange: (
        name: string,
        value: string | undefined,
        type?: 'unitSwitchers' | 'valueSelects',
    ) => void;
    setPropertyInputRef: (
        ref: EkaFocosableElement | Input | null,
        index: number,
        subIndex: number,
    ) => void;
    index: number;
    handleNextFocus: (index: number, subIndex: number) => void;
    unitPrefix?: string;
}> = ({
    argsKey,
    config,
    onValueChange,
    setPropertyInputRef,
    index,
    handleNextFocus,
    unitPrefix,
}) => {
    const arg = config?.calculator?.definition?.args?.[argsKey];
    const unitSwitcher = config?.calculator?.definition?.unitSwitchers[arg?.unitSwitcherId];
    const unitSwitcherOptions = unitSwitcher
        .map((item) => ({
            ...item,
            id: item.slug,
            value: item.name,
        }))
        .filter((item) => item.availability !== 'NOT_BY_DEFAULT');

    useEffect(() => {
        if (arg?.inputValue === undefined && arg?.ekaDefaultValue) {
            onValueChange(arg?.name, arg?.ekaDefaultValue);
        }
    }, [arg?.inputValue, arg?.ekaDefaultValue]);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        let value = e.target.value;
        // Allow only up to 2 decimal places
        value = value.replace(/^(\d+)(\.\d{0,2})?.*$/, (_, int, dec) => int + (dec || ''));
        if (arg?.inputValue !== value) {
            onValueChange(arg?.name, value || undefined);
        }
    };

    return (
        <div className={`flex justify-between w-full`}>
            <Input
                type={'number'}
                value={arg?.inputValue !== undefined ? arg?.inputValue : arg?.ekaDefaultValue}
                allowClear
                onChange={handleChange}
                ref={(ref) => {
                    if (!arg?.ekaDefaultValue) {
                        setPropertyInputRef(ref, index, 0);
                    }
                }}
                onPressEnter={() => handleNextFocus(index, 1)}
                className={'border-none calculators-container'}
                addonAfter={
                    <div className="flex items-center">
                        {unitPrefix && (
                            <div className="pr-16 bg-darwin-neutral-50 text-darwin-neutral-600">
                                {unitPrefix}
                            </div>
                        )}
                        <AntSelect
                            className="bg-darwin-neutral-50 text-darwin-neutral-600"
                            showArrow={false}
                            customDropdownWidth={180}
                            allowClear={false}
                            setRef={(ref) => setPropertyInputRef(ref, index, 1)}
                            placeholder={arg?.unitDefault}
                            optionFilterProp="children"
                            options={unitSwitcherOptions}
                            setValue={(option) => {
                                option?.slug &&
                                    arg.unitDefault !== option?.slug &&
                                    onValueChange(arg?.name, option.slug, 'unitSwitchers');

                                handleNextFocus(index + 1, 0);
                            }}
                            filterOption={true}
                            value={
                                unitSwitcherOptions.find((opt) => arg?.unitDefault === opt.slug) ||
                                undefined
                            }
                            getValue={(o) => o?.id}
                            getLabelToCompare={(o) => o.value}
                        />
                    </div>
                }
            />
        </div>
    );
};
